import { AppTour } from '../tour.model';

export const MANAGE_EMPLOYEE_INTRO_TOUR: AppTour = {
  tourId: 'manage-employee-intro-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'self',
      attachTo: { element: '#function-guide-4', on: 'right' },
      cancelIcon: {enabled: false},
      title: 'tour_manage_employee_intro_title',
      text: 'tour_manage_employee_intro_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};


export const MANAGE_EMPLOYEE_WIZARD_TOUR: AppTour = {

  tourId: 'manage-employee-wizard',
  showProgress: true,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'manage-employee-wizard-tour',
      attachTo: { element: '#step-guide-1', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_manage_employee_wizard_step1_title',
      text: 'tour_manage_employee_wizard_step1_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom', className:"btn btn-primary-tertiary btn-primary-tertiary--sm", handlerKey: 'onSkipClick'},
        { text: 'tour_label_add_employee', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
     } 
   ]
};

export const MANAGE_EMPLOYEE_INVITE_BUTTON_TOUR: AppTour = {

  tourId: 'manage-employee-invite-button-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide'},
  steps: [
    {
      id: 'manage-employee-invite-button-tour',
      attachTo: { element: '#btn-invite-employee-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_manage_employee_list_btn_title',
      text: 'tour_manage_employee_list_btn_text',
      parallel: true
     }
   ]
};

export const MANAGE_EMPLOYEE_INVITE_MORE_BUTTON_TOUR: AppTour = {

  tourId: 'manage-employee-invite-more-button-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide'},
  steps: [
    {
      id: 'manage-employee-invite-more-button-tour',
      attachTo: { element: '#btn-invite-employee-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      text: 'tour_manage_employee_invite_more_text',
      parallel: true
     }
   ]
};

export const INVITE_EMPLOYEE_FORM_TOUR: AppTour = {
  tourId: 'invite-employee-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide'},
  steps: [
    {
      id: 'invite-employee-form-tour',
      attachTo: { element: '#invite-employee-form-guide', on: 'left' },
      cancelIcon: {enabled: false},
      title: 'tour_manage_employee_form_title',
      text: 'tour_manage_employee_form_text',
      parallel: true
     }
   ]
};